import { Injectable, inject } from '@angular/core';
import { FileApi, SiaCacheDatabaseService } from '@sia/shared';
import { GridConfApi } from './grid-conf-api';

@Injectable({
  providedIn: 'root',
})
export class GridConfigService {
  private confApi = inject(GridConfApi);
  private cacheDatabaseService = inject(SiaCacheDatabaseService);
  private fileApi = inject(FileApi);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  //#region public methods

  getGridDefaultConfiguration(reference: any, gridId: string) {
    return this.confApi.getGridDefaultConfiguration(reference, gridId);
  }

  refreshGridConfiguration(perspective: string) {
    let config = this.confApi.refreshGridConfiguration(perspective);

    // return this.cacheDatabaseService
    // .setGridConfiguration(perspective, gridId, remoteConfig)
    // .then((_) => {
    //       //   //   "Ritorno la configurazione da remoto che ho salvato in cache"
    //   // );
    //   return remoteConfig;
    // });
    return config;
  }

  async remoteSaveGridConfigurationFile(form: any) {
    return await this.fileApi.uploadGridConfig(form);
  }
}
